// extracted by mini-css-extract-plugin
export default {"genericCard":"Mq-z","inline":"Nq-z","mastercard":"Oq-z","discover":"Pq-z","visa":"Qq-z","amex":"Rq-z","active":"Sq-z"};